import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch, PropType } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import LookupSingleSelect from "../lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";


export default /*#__PURE__*/_defineComponent({
  __name: 'select-user-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * Ids that will be excluded from the dropdown list
   * @type {number[]}
   * @default []
   */
  idsToHide: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
},
  emits: ["update:modelValue", "selectUser"],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

watch(
  () => showModal.value,
  () => {
    selectedUser.value = -1;
    selectedUserName.value = "";
  },
);

const onCancelClick = () => (showModal.value = false);

const selectedUser = ref(-1);
const selectedUserName = ref("");

const onValueChanged = (userName: string) => {
  if (!userName) {
    return;
  }

  selectedUserName.value = userName;
};

const onSelectClick = () => {
  showModal.value = false;
  emit("selectUser", selectedUser.value, selectedUserName.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
    title: "Users",
    width: _unref(ModalWidth).XSmall,
    onModalClosed: _cache[2] || (_cache[2] = ($event: any) => (emit('selectUser', undefined)))
  }, {
    content: _withCtx(() => [
      _createVNode(LookupSingleSelect, {
        modelValue: selectedUser.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedUser).value = $event)),
        lookupSource: _unref(LookupTableSource).Users,
        onValueChanged: onValueChanged,
        idsToHide: props.idsToHide
      }, null, 8, ["modelValue", "lookupSource", "idsToHide"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Select',
          disabled: selectedUser.value == -1,
          onClick: () => {
            onSelectClick();
          },
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})